import React, { useState, useEffect } from 'react'
import { AlertError } from '../../components'
import { Form, Sidebar } from './components'
import { useHistory, /* useLocation */ } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { reset, updateForm } from '../../features/event-form/slice'
import debounce from 'lodash.debounce'
import { setStatus } from '../../features/events/slice'
import { createEvent, fetchEvent, updateEvent } from '../../features/event/slice'
import { toast } from 'react-toastify'
import { emptyHolder } from '../../features/event-form/slice'
import ReschedulePopup from './components/reschedule-popup'

const DashboardEventForm = ({ match }) => {
  const id = match.params.id
  const isEdit = id
  const dispatch = useDispatch()
  const history = useHistory()
  const eventForm = useSelector(state => state.eventForm.data)
  // const query = new URLSearchParams(useLocation().search)
  const [showSidebar, setShowsidebar] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [requesting, setRequesting] = useState(false)
  const [showReschedulePopup, setShowReschedulePopup] = useState(false)

  // If query params ID exists, get the data
  useEffect(() => {
    if (id) {
      dispatch(fetchEvent(id)).finally(() => setShowsidebar(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isEdit) {
      dispatch(reset()).finally(() => setShowsidebar(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUpdateForm = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const isValid = () => {
    let result = true
    let msg = ''

    const {
      about_en,
      about_id
    } = eventForm

    // if(!eventForm.pin_point){
    //   result = false
    //   msg += 'Pin Point is required. '
    // }

    if(!about_en && !about_id){
      result = false
      msg += '"About" is required. '
    }

    if(msg !== ''){
      setErrorMessage(msg)
    }

    return result
  }

  const checkReschedule = (e) => {
    if(e.preventDefault){
      e.preventDefault()
    }

    if(isEdit){
      const {
        last_registration_start_date,
        last_registration_start_time,
        last_registration_end_date,
        last_registration_end_time,
        registration_start_date,
        registration_start_time,
        registration_end_date,
        registration_end_time,
        // note
      } = eventForm
      if(
        (
          last_registration_start_date !== registration_start_date ||
          last_registration_start_time !== registration_start_time ||
          last_registration_end_date !== registration_end_date ||
          last_registration_end_time !== registration_end_time
        )
        // && (!note || note === null)
      ){
        // Show rechedule note popup
        setShowReschedulePopup(true)
      } else {
        handleSubmit(e)
      }
    } else {
      handleSubmit(e)
    }
  }

  const handleSubmit = (e) => {
    if(e.preventDefault){
      e.preventDefault()
    }

    console.log({e, eventForm})

    setRequesting(true)
    setErrorMessage(null)

    let finalForm = {...eventForm}

    // Handle 'draft' status
    if(e.submission){
      finalForm.submission = e.submission
    }

    // Handle 'cancel' status
    if(e.statusActivity){
      finalForm.status_activity = e.statusActivity
      finalForm.cancel_reason = e.cancelReason
    }

    // Handle registration type
    if(eventForm.registrationType === 'internal'){
      finalForm.external_link = 'N/A'
      finalForm.external_link_need_update = true
    }

    if(isValid()){
      if(isEdit){
        dispatch(updateEvent({id: eventForm.id, data: finalForm}))
          .then((res) => {
            console.log(res)
            toast.success('Event successfully updated!')
            setStatus('idle')
            dispatch(emptyHolder({entity: 'gallery', type: 'update'}))
            dispatch(emptyHolder({entity: 'gallery', type: 'delete'}))
            history.push('/dashboard/events')
          })
          .catch(err => {
            setErrorMessage(err)
            console.log(err)
          })
          .finally(() => setRequesting(false))
      } else {
        dispatch(createEvent(finalForm))
          .then((res) => {
            console.log(res)
            toast.success('Event successfully created!')
            setStatus('idle')
            history.push('/dashboard/events')
          })
          .catch(err => {
            setErrorMessage(err)
            console.log(err)
          })
          .finally(() => setRequesting(false))
      }
    } else {
      setRequesting(false)
    }
  }

  return (
    <>
      {
        errorMessage !== null &&
        <div className="mb-8">
          <AlertError message={errorMessage} onClose={() => setErrorMessage(null)}/>
        </div>
      }
      <form
        className="flex flex-wrap -mx-4"
        onSubmit={checkReschedule}
      >
        <div className="w-full lg:w-2/3 pr-4 pl-4 lg:pr-8">
          <Form form={eventForm} updateForm={handleUpdateForm} isEdit={isEdit}/>
        </div>
        <div className="w-full lg:w-1/3 px-4">
          {
            showSidebar &&
            <Sidebar
              requesting={requesting}
              updateForm={handleUpdateForm}
              isEdit={isEdit}
              handleSubmit={checkReschedule}
            />
          }
        </div>
      </form>

      <ReschedulePopup
        showPopup={showReschedulePopup}
        setShowPopup={setShowReschedulePopup}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export { DashboardEventForm }
